import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { communityApi, type CommunityPriceEntry } from '../lib/domain';

// CMP-001..007: Preisvergleich über die EAN (siehe DECISIONS.md zur
// eigentümerübergreifenden Vergleichbarkeit).
export function ComparePage() {
  const [searchParams] = useSearchParams();
  const [ean, setEan] = useState(searchParams.get('ean') ?? '');
  const [onlyPromo, setOnlyPromo] = useState(false);
  const [prices, setPrices] = useState<CommunityPriceEntry[]>([]);
  const [loaded, setLoaded] = useState(false);

  async function search() {
    if (!ean.trim()) return;
    const res = await communityApi.byEan(ean.trim());
    setPrices(res.prices);
    setLoaded(true);
  }

  // Von der Produktseite aus per EAN vorausgefüllt aufrufbar (?ean=...).
  useEffect(() => {
    const initialEan = searchParams.get('ean');
    if (initialEan) void search();
    // Nur beim ersten Rendern mit vorausgefülltem Parameter ausführen.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = onlyPromo ? prices.filter((p) => p.isPromo) : prices;
  const maxPrice = Math.max(1, ...filtered.map((p) => Number(p.price)));

  return (
    <div className="stack">
      <h1>Preisvergleich (Community)</h1>
      <p className="muted">Öffentlich, anonymisiert - ohne Anmeldung Community-Daten teilen bitte in den Einstellungen aktivieren.</p>
      <div className="card row">
        <input value={ean} onChange={(e) => setEan(e.target.value)} placeholder="EAN eingeben" />
        <button className="primary" onClick={search}>
          Vergleichen
        </button>
      </div>
      <label className="row">
        <input type="checkbox" checked={onlyPromo} onChange={(e) => setOnlyPromo(e.target.checked)} />
        Nur Aktionspreise
      </label>

      {loaded && filtered.length === 0 && (
        <p className="muted">
          Keine freigegebenen Preisdaten gefunden. Hinweis: Hier erscheinen nur Preise von Nutzer:innen (auch von dir selbst), die
          das Teilen von Community-Daten in den Einstellungen aktiviert haben - die eigenen zuletzt gekauften/beobachteten Preise
          eines Produkts findest du unabhängig davon auf der jeweiligen Produktseite.
        </p>
      )}

      <ul className="list-reset stack">
        {filtered.map((p) => (
          <li key={p.id} className="card">
            <div className="row between">
              <strong>{p.productNameSnapshot}</strong>
              {p.isPromo && <span className="badge ok">Aktion</span>}
            </div>
            <div className="muted">
              {new Date(p.observedAt).toLocaleDateString('de-DE')} {p.roughArea && `· ${p.roughArea}`}
            </div>
            <div className="row" style={{ marginTop: 8 }}>
              <div style={{ background: 'var(--color-primary)', height: 8, borderRadius: 4, width: `${(Number(p.price) / maxPrice) * 100}%` }} />
              <strong>{Number(p.price).toFixed(2)} €</strong>
              {p.baseUnitPrice && <span className="muted">({Number(p.baseUnitPrice).toFixed(2)} {p.baseUnit})</span>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
